/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Caching stats
 * @export
 * @interface CachingSummary
 */
export interface CachingSummary {
    /**
     * Number of cache hits
     * @type {string}
     * @memberof CachingSummary
     */
    'cacheHits': string;
    /**
     * Cache mode for this database
     * @type {string}
     * @memberof CachingSummary
     */
    'cacheMode'?: CachingSummaryCacheModeEnum;
    /**
     * Percentage of database time saved by caching
     * @type {number}
     * @memberof CachingSummary
     */
    'dbTimeSavePercentage': number;
    /**
     * Total number of DQL queries observed
     * @type {string}
     * @memberof CachingSummary
     */
    'dqlQueries'?: string;
    /**
     * Percentage of queries served from cache
     * @type {number}
     * @memberof CachingSummary
     */
    'hitRate': number;
    /**
     * Projected number of cache hits
     * @type {string}
     * @memberof CachingSummary
     */
    'projectedCacheHits'?: string;
    /**
     * Projected percentage of database time saved
     * @type {number}
     * @memberof CachingSummary
     */
    'projectedDbTimeSavePercentage'?: number;
    /**
     * Projected cache hit rate as a percentage
     * @type {number}
     * @memberof CachingSummary
     */
    'projectedHitRate'?: number;
    /**
     * Total number of queries observed
     * @type {string}
     * @memberof CachingSummary
     */
    'totalQueries'?: string;
    /**
     * Total execution time in milliseconds.
     * @type {string}
     * @memberof CachingSummary
     */
    'totalTimeMs'?: string;
}

export const CachingSummaryCacheModeEnum = {
    CACHE_MODE_UNSPECIFIED: 'CACHE_MODE_UNSPECIFIED',
    ON: 'ON',
    PASSTHROUGH: 'PASSTHROUGH',
    OFF: 'OFF'
} as const;

export type CachingSummaryCacheModeEnum = typeof CachingSummaryCacheModeEnum[keyof typeof CachingSummaryCacheModeEnum];


